import R from 'ramda';
import PropTypes from 'prop-types';

export const breakpointPropShape = PropTypes.shape({
  contentAlignment: PropTypes.object,
  gridSetup: PropTypes.object,
  swatchLimit: PropTypes.number,
});

// TODO: [1] get this from SCSS
const getGridColumnsTotal = () => 16;

const isImageOffsetTop = ({ config }) => (
  config
  && config.contentOverlay
  && config.contentOverlay.verticalOffsetType === 'outside'
  && config.contentAlignment.vertical === 'top'
);

const isImageOffsetBottom = ({ config }) => (
  config
  && config.contentOverlay
  && config.contentOverlay.verticalOffsetType === 'outside'
  && config.contentAlignment.vertical === 'bottom'
);

// Breakpoint config should be additive. Start with a base config (xsmall) and overwrite with more specific/granular
// config when a more relevant breakpoint config value(s) is given
const getBreakpointConfig = ({
  currentBreakpoint,
  xsmall,
  small,
  medium,
  large,
  xlarge,
}) => {
  const breakpointsMap = [
    { 'xsmall': xsmall },
    { 'small': small },
    { 'medium': medium },
    { 'large': large },
    { 'xlarge': xlarge },
  ];

  const breakpointIndex = R.findIndex(R.has(currentBreakpoint), breakpointsMap);

  // i.e. Breakpoints up to and including the current (starting at xsmall)
  const relevantBreakpointsMap = R.compose(
    R.head,
    R.splitAt(breakpointIndex + 1),
  )(breakpointsMap);


  return R.reduce((acc, val) => {
    const breakpointConfig = R.compose(R.head, R.values)(val);

    if (breakpointConfig) {
      return R.mergeDeepRight(acc, breakpointConfig);
    }

    return acc;
  }, {}, relevantBreakpointsMap);
};

const getIsContentFirst = ({
  contentOverlay,
  contentAlignment,
  imageColumns,
  contentColumns,
}) => {
  if (contentOverlay) {
    return false;
  }

  // No overlay (stacked). Note: centering the content vertically or horizontally is not valid when stacked.
  const isVertical = imageColumns + contentColumns > getGridColumnsTotal();
  if (
    (isVertical && contentAlignment.vertical === 'top')
    || (!isVertical && contentAlignment.horizontal === 'left')
  ) {
    return true;
  }

  if (
    (isVertical && contentAlignment.vertical === 'bottom')
    || (!isVertical && contentAlignment.horizontal === 'right')
  ) {
    return false;
  }

  throw new Error([
    'Invalid config. Remember that:',
    '-> Vertical alignment must be top or bottom when content is not overlaid.',
    // eslint-disable-next-line
    '-> Image and content columns must total greater than the number of grid columns.',
    // TODO is this because horizontal isn't implemented yet?
  ].join('\n'));
};

export {
  getGridColumnsTotal,
  isImageOffsetTop,
  isImageOffsetBottom,
  getBreakpointConfig,
  getIsContentFirst,
};
